// extracted by mini-css-extract-plugin
export var company = "styles-module--company--f105a";
export var companyName = "styles-module--companyName--733bc";
export var hiddenScrollbar = "styles-module--hiddenScrollbar--e5695";
export var linkButton = "styles-module--linkButton--93473";
export var logo = "styles-module--logo--2bbef";
export var logoRow = "styles-module--logoRow--e6d19";
export var opened = "styles-module--opened--8f745";
export var section = "styles-module--section--ff448";
export var sectionHeading = "styles-module--sectionHeading--5ef28";
export var sections = "styles-module--sections--0c685";
export var subSection = "styles-module--subSection--89012";
export var subSectionLink = "styles-module--subSectionLink--4d677";
export var subSectionLinkImage = "styles-module--subSectionLinkImage--d0d6b";
export var subSectionLinkTitle = "styles-module--subSectionLinkTitle--aa700";
export var subSections = "styles-module--subSections--2fd4a";
export var toggleButton = "styles-module--toggleButton--f6472";
export var wrapper = "styles-module--wrapper--fe24b";